"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_apollo_1 = require("react-apollo");
var QueryTags = require("../../core/gql/queries/tags");
var tag_1 = require("../../models/tag");
var organization_tag_1 = require("./organization-tag");
var OrgStructure = function (_a) {
    var _b;
    var orgId = _a.orgId;
    var queryTags = react_apollo_1.useQuery(QueryTags.QUERY, { variables: { organizationId: orgId } });
    var tags = (_b = queryTags.data) === null || _b === void 0 ? void 0 : _b.tags;
    return (React.createElement("div", null,
        React.createElement(organization_tag_1.default, { orgId: orgId, orgTags: tags, tagTypeName: tag_1.TagType.AREA_OF_OPERATION }),
        React.createElement(organization_tag_1.default, { orgId: orgId, orgTags: tags, tagTypeName: tag_1.TagType.AGE_DIVISION }),
        React.createElement(organization_tag_1.default, { orgId: orgId, orgTags: tags, tagTypeName: tag_1.TagType.COMPETITION_GENDER }),
        React.createElement(organization_tag_1.default, { orgId: orgId, orgTags: tags, tagTypeName: tag_1.TagType.COMPETITION_LEVEL })));
};
exports.default = OrgStructure;
//# sourceMappingURL=organization-structure.js.map